import React from 'react';

function TextInput(props) {
    return (
        <input type="text" className="form-control" onChange={props.onChange} {...props} />
    );
}

export default TextInput;